<template>
  <app-page>
    <template #main>
      <div>
        <!-- <el-radio-group v-model="divideType" size="medium">
          <el-radio-button label="bb">百布清分模版</el-radio-button>
        </el-radio-group> -->
        <div class="title">
          <div style="margin-right: 10px;">一、下载清分客户模版</div>
          <el-button
            :size="formSize"
            type="primary"
            icon="el-icon-download"
            :loading="downloadLoading"
            @click="downLoadTemp"
          >
            下载模版
          </el-button>
        </div>
        <div class="margin-space">下载用例导入模版，按照以下规则填写导入数据</div>
        <jr-table
          :tableData="bbDivideList"
          :tableColumn="tableColumn"
        />
        <div class="title margin-space">二、上传文件</div>
        <div class="text">上传需要导入的Excel文件，上传文件的表头字段名必须和对应工作项属性一致。仅支持xlsx,xls</div>
        <el-alert
          title="手动清分每次只能上传10000条数据，文件大小不能大于10M"
          type="warning"
          :closable="false"
          style="margin: 8px 0;"
        />
        <jr-file-upload
          acceptFileType="xlsx|xls"
          accept=".xlsx,.xls"
          :uploadFileUrl="uploadFileUrl"
          @change="uploadChange"
          @error="uploadError"
          :list="files"
          :resetFlag="resetFile"
          :fileSize="10"
        />
      </div>
      <div style="text-align:center; margin-top: 15px">
        <el-button
          type="primary" @click="submitForm" :size="formSize" :loading="submitLoading"
          v-track
          trackCode='divideConfig-1'
        >确认提交</el-button>
      </div>
    </template>
  </app-page>
</template>

<script>
import { bbDivideDownload, bbDivideUpload } from '@/api/operations';
import fileDownloadMixins from '@/mixins/file-download';
import { UPLOAD_FILE_API } from '@/api/global';
import { getAccount } from '@/utils/account';

export default {
  mixins: [fileDownloadMixins],
  data() {
    return {
      uploadFileUrl: UPLOAD_FILE_API,
      divideType: 'bb',
      downloadLoading: false,
      tableColumn: [
        { label: '字段', prop: 'field' },
        { label: '字段说明', prop: 'fieldDesc' },
        { label: '字段标识', prop: 'mark' },
      ],
      bbDivideList: [
        { field: '订单号', fieldDesc: 'orderNumer', mark: '必传' },
        { field: '服务商编号', fieldDesc: 'businessNo', mark: '必传' },
        { field: '服务商名称', fieldDesc: 'businessName', mark: '必传' },
        { field: '码单状态', fieldDesc: '-', mark: '-' },
        { field: '采购商码单确认时间', fieldDesc: '-', mark: '-' },
        { field: '订单应收金额', fieldDesc: '元', mark: '必传' },
        { field: '技术费', fieldDesc: '元', mark: '必传' },
        { field: '是否金融', fieldDesc: '-', mark: '-' },
        { field: '技术费结算方式', fieldDesc: '-', mark: '-' },
      ],
      file: '',
      files: [],
      submitLoading: false,
      resetFile: false,
    };
  },
  methods: {
    // 下载模版
    async downLoadTemp() {
      try {
        this.downloadLoading = true;
        const res = await this.exportByBlob({
          data: {},
          url: bbDivideDownload,
        });
        if (res && res.status === 200) {
          // 数据延迟处理，即接口返回200但文件流还没处理完成
          this.$message.success('下载成功！！');
        }
        this.downloadLoading = false;
      } catch (error) {
        this.downloadLoading = false;
        console.log(error);
      }
    },
    uploadChange({ file, fileList }) {
      this.file = file;
      this.files = fileList;
    },
    uploadError() {
      this.file = '';
      this.files = [];
    },
    // 确认
    async submitForm() {
      if (!this.file) {
        this.$message.warning('请上传文件');
        return;
      }
      try {
        this.submitLoading = true;
        const form = new FormData();
        const { raw } = this.file;
        const account = getAccount();
        form.append('file', raw); // 文件
        form.append('currentUserId', account ? account.id : '');
        form.append('operator', account ? account.userName : '');
        const res = await bbDivideUpload(form);
        const { data } = res;
        if (data.urlPath) {
          window.open(data.urlPath);
        }
        this.$message.success('操作成功');
        this.submitLoading = false;
        this.file = '';
        this.files = [];
        this.resetFile = true;
      } catch (error) {
        console.log(error);
        this.submitLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .jr-file-upload {
    width: 100%;
    .el-upload {
      width: 100%;
    }
  }
}
.title {
  display: flex;
  align-items: center;
  color: #000;
  font-weight: 600;
  font-size: 16px;
}
.margin-space {
  margin: 12px 0;
}
.text {
  line-height: 22px;
}
</style>
